import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "ml-3" }

import { PropType } from 'vue';
import { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/vue/20/solid';

type AlertType = 'success' | 'info' | 'warning' | 'danger'


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertComponent',
  props: {
  type: {
    type: String as PropType<AlertType>,
    default: 'warning',
  },
  hasBorder: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['rounded-md p-4',
                __props.hasBorder ? 'border' : '',
                __props.type === 'success' ? 'border-green-200 bg-green-50 [&>a]:text-green-600 [&>a]:hover:text-green-800' : '',
                __props.type === 'info' ? 'border-blue-200 bg-blue-50 [&>a]:text-blue-600 [&>a]:hover:text-blue-800' : '',
                __props.type === 'warning' || __props.type === 'danger' ? 'border-yellow-200 bg-yellow-50 [&>a]:text-yellow-600 [&>a]:hover:text-yellow-800' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.type === 'success')
          ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
              key: 0,
              class: "h-6 w-6 text-green-400",
              "aria-hidden": "true"
            }))
          : (__props.type === 'info')
            ? (_openBlock(), _createBlock(_unref(InformationCircleIcon), {
                key: 1,
                class: "h-6 w-6 text-blue-400",
                "aria-hidden": "true"
              }))
            : (__props.type === 'warning' || __props.type === 'danger')
              ? (_openBlock(), _createBlock(_unref(ExclamationTriangleIcon), {
                  key: 2,
                  class: "h-6 w-6 text-yellow-400",
                  "aria-hidden": "true"
                }))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", {
          class: _normalizeClass([__props.type === 'success' ? 'text-green-800' : '',
                    __props.type === 'info' ? 'text-blue-700' : '',
                    __props.type === 'warning' || __props.type === 'danger' ? 'text-yellow-700' : ''])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ])
    ])
  ], 2))
}
}

})